<div class="widget dx-card" #widgetWrapper>
    <!-- Normal mode -->
    <ng-container *ngIf="!(dashboardDataService.edit$ | async)">
        <div #widgetHeader class="widget-header dx-card" *ngIf="!(item.type === 'EmptyWidget')">
          <div class="wrapper">
            <h2 class="widget-header-title">{{item.options?.title}}</h2>
            <div class="d-flex column-gap-2 align-items-center">
                <h6 class="widget-subtitle" *ngIf="item.options?.subtitle">{{item.options?.subtitle}}</h6>
                <div class="supplier-state" *ngIf="supplierState !== null" [ngClass]="{'active' : supplierState === true}"></div>
            </div>
          </div>
            <div class="widget-header-buttons">
                <dx-button *ngIf="item.hasRefreshButton" icon="refresh" stylingMode="text" (onClick)="onRefresh()"></dx-button>
                <dx-button *ngIf="setingsComponent != null" icon="edit" stylingMode="text" (click)="openSettings()"></dx-button>
                <dx-button *ngIf="!dashboardDataService.fullScreenMode" icon="fullscreen" stylingMode="text" (click)="dashboardDataService.fullScreenWidget(item)"></dx-button>
                <dx-button *ngIf="dashboardDataService.fullScreenMode" icon="minus" stylingMode="text" (click)="dashboardDataService.fullScreenWidget(item)"></dx-button>
            </div>
        </div>
        <div class="widget-content">
            <ng-template #widgetContainer></ng-template>
        </div>
    </ng-container>

    <!-- Edit mode -->
    <ng-container *ngIf="dashboardDataService.edit$ | async">
        <div class="widget-empty">
            <div class="widget-header dx-card">
                <dx-button icon="trash" stylingMode="text" (click)="deleteWidget()"></dx-button>
            </div>
            <dx-select-box
                class="widget-empty-select"
                displayExpr="name"
                valueExpr="type"
                fieldTemplate="field"
                [dataSource]="widgetComponentsList"
                [inputAttr]="{ 'aria-label': 'Templated Product' }"
                (onValueChanged)="changeType($event)"
                [value]="item.type"
            >
                <div *dxTemplate="let data of 'field'">
                    <div class="select-type-row">
                        <div *ngIf="data && data.icon" [innerHTML]="getSafeSvgIcon(data.icon)"></div>
                        <dx-text-box
                            [value]="data ? data.name : 'Empty'"
                            [inputAttr]="{ 'aria-label': 'Name' }"
                            [readOnly]="true"
                        ></dx-text-box>
                    </div>
                </div>

                <div *dxTemplate="let data of 'item'">
                    <div class="select-type-row">
                        <div *ngIf="data && data.icon" [innerHTML]="getSafeSvgIcon(data.icon)"></div>
                        <span>
                            {{ data.name }}
                        </span>
                    </div>
                </div>
            </dx-select-box>
        </div>
    </ng-container>
</div>

<ng-template #settingsContainer></ng-template>
